// extracted by mini-css-extract-plugin
export var icon = "_q9-0";